const TRANSLATED_DAYS_OF_WEEK = ['SEGUNDA-FEIRA', 'TERÇA-FEIRA', 'QUARTA-FEIRA', 'QUINTA-FEIRA', 'SEXTA-FEIRA', 'SÁBADO', 'DOMINGO']

const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']

export const abbreviateDay = (day) => {
  return day ? day.charAt(0).toUpperCase() + day.substring(1, 3).toLowerCase() : ''
}

export const calculateDaysInterval = (initialDay, finalDay) => {
  const initialIndex = DAYS_OF_WEEK.indexOf(initialDay.toUpperCase())
  const finalIndex = DAYS_OF_WEEK.indexOf(finalDay.toUpperCase())

  if (initialIndex === -1 || finalIndex === -1) {
    return false
  }

  let daysInterval

  if (finalIndex >= initialIndex) {
    daysInterval = finalIndex - initialIndex + 1
  } else {
    daysInterval = DAYS_OF_WEEK.length - initialIndex + finalIndex + 1
  }

  return daysInterval === 1 ? '1 dia' : `${daysInterval} dias`
}

export const getDaysIntervalLabel = (initialDay) => {
  if (initialDay) {
    const initialIndex = DAYS_OF_WEEK.indexOf(initialDay.toUpperCase())
    const finalIndex = initialIndex ? initialIndex - 1 : TRANSLATED_DAYS_OF_WEEK.length - 1
    return `${abbreviateDay(TRANSLATED_DAYS_OF_WEEK[initialIndex])} ~ ${abbreviateDay(TRANSLATED_DAYS_OF_WEEK[finalIndex])}`
  } else return ''
}
